{
  "title": "Book a facility",
  "lead": "Courts, gyms and halls you can borrow from the LGU. See when they're free and send a booking request.",
  "empty": "No facilities are open for booking yet",
  "emptyBody": "When an office lists its courts, gyms or halls, you can book them here.",
  "capacity": "Up to {count} people",
  "needsApproval": "Needs approval",
  "instant": "Booked right away",
  "myBookings": "My bookings",
  "noBookings": "You haven't booked a facility yet.",
  "back": "All facilities",
  "about": "About this facility",
  "where": "Where",
  "getDirections": "Get directions",
  "hours": "Bookable hours",
  "closed": "Closed",
  "fees": "Fees",
  "rules": "Rules",
  "terms": "How booking works",
  "termNotice": "Book at least {count} days ahead.",
  "termNoticeOne": "Book at least 1 day ahead.",
  "termNoticeNone": "Same-day bookings are allowed.",
  "termMax": "Up to {hours} hours per booking.",
  "termApproval": "The office reviews each request and lets you know.",
  "termInstant": "If the time is free, your booking is confirmed at once.",
  "availability": "When it's free",
  "availabilityLead": "Booked and requested times are shown. Names are never shown.",
  "prevWeek": "Previous week",
  "nextWeek": "Next week",
  "thisWeek": "This week",
  "booked": "Booked",
  "requested": "Requested",
  "freeAllDay": "Free during open hours",
  "bookTitle": "Request a booking",
  "signInToBook": "Sign in to book this facility",
  "date": "Date",
  "start": "Start",
  "end": "End",
  "chooseDate": "Choose a date first.",
  "closedThatDay": "Closed on that day. Choose another date.",
  "purpose": "What is it for?",
  "purposeHint": "For example: \"Barangay youth basketball practice\".",
  "participants": "Expected number of people",
  "participantsHint": "At most {count}.",
  "contactName": "Contact person",
  "contactMobile": "Mobile number",
  "contactHint": "The office may call or text about your booking.",
  "send": "Send booking request",
  "sending": "Sending…",
  "checkForm": "Please check the highlighted fields.",
  "status_pending": "Waiting for approval",
  "status_approved": "Approved",
  "status_declined": "Declined",
  "status_cancelled": "Cancelled",
  "bookingTitle": "Booking {ref}",
  "bookingLead": "Show this reference at the facility or the office if asked.",
  "pendingNote": "{office} will review your request and notify you.",
  "approvedNote": "Your booking is confirmed.",
  "officeNote": "Note from {office}",
  "when": "When",
  "people": "{count} people",
  "addToCalendar": "Add to calendar",
  "cancel": "Cancel booking",
  "cancelTitle": "Cancel this booking?",
  "cancelBody": "The time becomes free for others. You can book again if it's still free.",
  "cancelYes": "Yes, cancel",
  "keep": "Keep it",
  "cancelled": "Your booking was cancelled.",
  "notFound": "We couldn't find this booking.",
  "lastUpdated": "Last updated by {office} on {date}",
  "staffTitle": "Facilities",
  "staffLead": "Your office's courts, gyms and halls, and the booking requests for them.",
  "tabBookings": "Bookings",
  "tabCalendar": "Week view",
  "tabFacilities": "Facilities",
  "filterPending": "Pending",
  "filterApproved": "Approved",
  "filterAll": "All",
  "allFacilities": "All facilities",
  "facility": "Facility",
  "exportCsv": "Export CSV",
  "noStaffBookings": "No bookings here",
  "noStaffBookingsBody": "New requests from residents appear here.",
  "conflictWarning": "Overlaps with {refs}. Only one can be approved.",
  "approve": "Approve",
  "decline": "Decline",
  "staffCancel": "Cancel booking",
  "approveTitle": "Approve {ref}?",
  "approveNote": "Note to the resident",
  "approveNoteHint": "Optional, e.g. where to get the key.",
  "declineTitle": "Decline {ref}?",
  "declineNote": "Reason for the resident",
  "staffCancelTitle": "Cancel {ref}?",
  "staffCancelNote": "Reason for the resident",
  "noteRequired": "Tell the resident why.",
  "approvedToast": "Booking approved. The resident has been notified.",
  "declinedToast": "Booking declined. The resident has been notified.",
  "cancelledToast": "Booking cancelled. The resident has been notified.",
  "decidedBy": "by {name}",
  "requestedOn": "Requested {date}",
  "weekOf": "Week of {date}",
  "noFacilities": "No facilities yet",
  "noFacilitiesBody": "Add your office's courts, gyms or halls so residents can book them.",
  "addFacility": "Add a facility",
  "editFacility": "Edit facility",
  "newFacility": "New facility",
  "inactive": "Hidden",
  "pendingCount": "{count} pending",
  "upcomingCount": "{count} upcoming",
  "readOnly": "You can view bookings. Editors and office heads can approve them and edit facilities.",
  "name": "Name",
  "description": "Description",
  "location": "Address or location",
  "pin": "Map pin",
  "pinHint": "Optional. Helps residents find it.",
  "barangay": "Barangay",
  "capacityField": "Capacity (people)",
  "photos": "Photos",
  "feesField": "Fees",
  "feesHint": "As set by ordinance, e.g. \"₱200 per hour\". Leave empty if free.",
  "rulesField": "Rules",
  "hoursField": "Bookable hours",
  "openDay": "Open",
  "opens": "Opens",
  "closes": "Closes",
  "slotMinutes": "Booking steps",
  "slotHint": "Bookings start and end on these steps.",
  "minutes": "{count} minutes",
  "minNotice": "Minimum notice (days)",
  "maxHours": "Maximum hours per booking",
  "requiresApproval": "Review each request before it is confirmed",
  "requiresApprovalHint": "Turn off to confirm free times at once.",
  "active": "Show to residents",
  "sort": "Order",
  "save": "Save facility",
  "saved": "Facility saved.",
  "uploading": "Uploading photos…"
}
